import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f8a22046&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f8a22046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a22046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a22046')) {
      api.createRecord('f8a22046', component.options)
    } else {
      api.reload('f8a22046', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f8a22046&scoped=true&", function () {
      api.rerender('f8a22046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tt0K076N0Toz/JS/comp/DocBox.vue"
export default component.exports